<template>
  <Web :isTestPortal="true"></Web>
</template>
<script>
import Web from "./web.vue";

export default {
  name: "test-portal-web-wrapper",
  components: {
    Web
  }
};
</script>
